export const BRAND = "Diva Nail Beauty";
export const SLOGAN = "Kendinin En Güzel Hâli";
export const PHONE_DISPLAY = "0534 960 08 62";
export const PHONE_TEL = "tel:+905349600862";
export const WHATSAPP = "https://wa.me/905349600862?text=Merhaba%2C%20Diva%20Nail%20Beauty%20i%C3%A7in%20randevu%20almak%20istiyorum.";
export const INSTAGRAM_HANDLE = "@diva.nailbeauty";
export const INSTAGRAM_URL = "https://www.instagram.com/diva.nailbeauty";
export const ADDRESS = "Barbaros Hayrettin Paşa, 1995. Sk., 34515 Esenyurt / İstanbul";
export const MAP_EMBED = "https://maps.google.com/maps?ll=41.01615,28.64248&z=17&t=m&hl=tr&output=embed";
export const MAP_LINK = "https://www.google.com/maps/search/?api=1&query=Barbaros+Hayrettin+Pa%C5%9Fa+1995.+Sk.+34515+Esenyurt+%C4%B0stanbul";
export const WHATSAPP_BASE = "https://wa.me/905349600862";
export const AGENCY = { name: "Bana Bi Media", label: "Web Sitesi ve Dijital Çözümler", whatsapp: "https://wa.me/905324751871?text=Merhaba%2C%20web%20sitesi%20ve%20dijital%20%C3%A7%C3%B6z%C3%BCmler%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum." };
export const LOGO = "/assets/logo.png";
export const LOGO_WHITE = "/assets/logo-intro.png";
export const LOGO_INTRO = "/assets/logo-intro.png";
export const OPENING_HOURS = {
  timeZone: "Europe/Istanbul",
  week: [
    { day: 1, label: "Pazartesi", open: "10:00", close: "20:00" },
    { day: 2, label: "Salı", open: "10:00", close: "20:00" },
    { day: 3, label: "Çarşamba", open: "10:00", close: "20:00" },
    { day: 4, label: "Perşembe", open: "10:00", close: "20:00" },
    { day: 5, label: "Cuma", open: "10:00", close: "20:00" },
    { day: 6, label: "Cumartesi", open: "10:00", close: "20:00" },
    { day: 0, label: "Pazar", open: "10:00", close: "20:00" },
  ],
};

export const PRICES = [
  { id: "tirnak", title: "Tırnak Bakımı", imageKey: "protez", items: [
    { name: "Manikür", price: "400 TL" },
    { name: "Islak Manikür", price: "500 TL" },
    { name: "Protez Tırnak", price: "900 TL", badge: "Popüler" },
    { name: "Jel Güçlendirme", price: "850 TL" },
    { name: "Kalıcı Oje", price: "800 TL", campaign: { newPrice: "650 TL", until: "2026-12-31" } },
    { name: "Çıkartma İşlemi", price: "350 TL" },
  ] },
  { id: "ayak", title: "Ayak Bakımı", imageKey: "pedikur", items: [
    { name: "Pedikür + Oje", price: "1.000 TL" },
    { name: "Islak Pedikür + Oje", price: "1.200 TL", campaign: { newPrice: "1.000 TL", until: "2026-11-30" } },
  ] },
  { id: "cilt", title: "Cilt Bakımı", imageKey: "cilt", items: [
    { name: "Medikal Cilt Bakımı", price: "1.000 TL" },
    { name: "Hydrafacial Cilt Bakımı", price: "1.500 TL", badge: "Yeni" },
  ] },
];

const IMG = "https://static.prod-images.emergentagent.com/jobs/cb4257f1-0375-4523-81e7-50256e1fefae/images/";
export const IMAGES = {
  hero: `${IMG}3d5eba9133841fda8edf015748f0a7867f9d0068c6120e4e8dd26116499ea022.jpeg`,
  nailart: `${IMG}5f263159faf13430d79b32e5126c369ef0bfcdd8594ef594e94973e46e6043e6.jpeg`,
  kirpik: `${IMG}9f5ce4941ba8b399196ffe1524903302634f5f7dbda57306097a9782a6dbd783.jpeg`,
  manikur: `${IMG}ee52ab4fe3f308ed4434c4d65037540237e95cf1c2c44339aa25fc9858c170c6.jpeg`,
  cilt: `${IMG}ecb09a6511d4623456e35c69c33963c565407d31842a54506dbd18a5350dfd62.jpeg`,
  pedikur: `${IMG}9611a4c3fef60eba1461febb45ac32809e0cb9f6e42df209e863df113103f592.jpeg`,
  protez: `${IMG}3772c51875a3f990ef6d6942c110a61b3f5f0dfadf00562c9a061437ea5ccbd1.jpeg`,
  salon: `${IMG}a4d2796d925ab86d13e9d4a36052d31f4919b230dad81b9c941061abb973ecf1.jpeg`,
  about: "/assets/about-salon.jpg",
};

export const SERVICES = [
  { id: "protez-tirnak", name: "Protez Tırnak", seo: "Esenyurt Protez Tırnak", desc: "Estetik, dayanıklı ve şık tırnak uygulamaları", image: IMAGES.protez },
  { id: "manikur", name: "Manikür", seo: "Esenyurt Manikür", desc: "Bakımlı ve zarif eller için profesyonel dokunuş", image: IMAGES.manikur },
  { id: "pedikur", name: "Pedikür", seo: "Esenyurt Pedikür", desc: "Ayak bakımında hijyen ve konfor", image: IMAGES.pedikur },
  { id: "ipek-kirpik", name: "İpek Kirpik", seo: "Esenyurt İpek Kirpik", desc: "Daha etkileyici ve belirgin bakışlar", image: IMAGES.kirpik },
  { id: "cilt-bakimi", name: "Cilt Bakımı", seo: "Esenyurt Cilt Bakımı", desc: "Cildinize canlılık ve tazelik kazandıran profesyonel bakım", image: IMAGES.cilt },
];

export const WHY_US = [
  { title: "Hijyenik Ortam", desc: "Sterilize ekipmanlar, tek kullanımlık malzemeler ve yüksek hijyen standartları." },
  { title: "Profesyonel Hizmet", desc: "Alanında uzman, deneyimli ve güler yüzlü güzellik uzmanları." },
  { title: "Kaliteli Uygulamalar", desc: "Kalıcı, estetik ve sağlığınızı koruyan premium ürünler." },
  { title: "Müşteri Memnuniyeti", desc: "Kişiye özel ilgi, memnuniyet odaklı hizmet anlayışı." },
  { title: "Şık ve Modern Salon", desc: "Instagram estetiğinde, huzurlu ve lüks bir salon deneyimi." },
];

export const GALLERY = [
  { src: IMAGES.nailart, alt: "Esenyurt protez tırnak french nail art – Diva Nail Beauty", span: "md:col-span-2 md:row-span-2" },
  { src: IMAGES.kirpik, alt: "Esenyurt ipek kirpik uygulaması – Diva Nail Beauty", span: "" },
  { src: IMAGES.cilt, alt: "Esenyurt cilt bakımı – Diva Nail Beauty", span: "" },
  { src: IMAGES.salon, alt: "Diva Nail Beauty Esenyurt güzellik salonu iç mekan", span: "md:col-span-2" },
  { src: IMAGES.manikur, alt: "Esenyurt manikür – Diva Nail Beauty", span: "" },
  { src: IMAGES.pedikur, alt: "Esenyurt pedikür – Diva Nail Beauty", span: "" },
  { src: IMAGES.protez, alt: "Esenyurt protez tırnak uygulaması – Diva Nail Beauty", span: "" },
  { src: IMAGES.hero, alt: "Soft pembe protez tırnak – Diva Nail Beauty Esenyurt", span: "" },
];

export const MARQUEE_ITEMS = [
  "Esenyurt Güzellik Salonu", "Protez Tırnak", "Manikür", "Pedikür", "İpek Kirpik", "Cilt Bakımı", "İstanbul Güzellik Salonu", "Kendinin En Güzel Hâli",
];

export const NAV = [
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Fiyatlar", href: "#fiyatlar" },
  { label: "Galeri", href: "#galeri" },
  { label: "Yorumlar", href: "#yorumlar" },
  { label: "İletişim", href: "#iletisim" },
];
